import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDomDistance } from '@src/utils/index';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const FormTitle = ({ title, warningText, isRequired }) => {
    const titleRef = useRef();

    useEffect(() => {
        if (warningText?.isScrollTop) {
            const domPageTop = getDomDistance(titleRef.current).top;

            if (domPageTop) {
                window.scroll({ top: domPageTop, behavior: 'smooth' });
            }
        }
    }, [warningText]);

    return (
        <div ref={titleRef} className={styles.formNameBox}>
            <div className={styles.formName}>{title}<span className={styles.formNameStart}>{isRequired ? '*' : ''}</span></div>
            {warningText?.value && <div className={styles.formWarning}>{warningText.value}</div>}
        </div>
    );
};

FormTitle.propTypes = {
    title: PropTypes.string,
    warningText: PropTypes.object,
    isRequired: PropTypes.bool
};

export default errorBoundary(FormTitle);
